import { HomePage } from 'pages/HomePage';
import './App.scss';
import { Route, Routes } from 'react-router';
import { CaseStudyPage } from 'pages/CaseStudyPage';
import { APP_ROUTES } from 'routes';

const App = () => {
  return (
    <div className='app'>
      <Routes>
        <Route path={APP_ROUTES.HOME.route} element={<HomePage />} />
        <Route path={APP_ROUTES.CASE_STUDIES.route} element={<CaseStudyPage />} />
      </Routes>
    </div>
  );
};

export default App;
